module.exports = __webpack_public_path__ + "static/assets/8a97603aa0ff415d051942ef96bee5cc.svg";